package ui.eReceipt.receiptTypes

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.flow.StateFlow
import model.MerchantFullInformationV3
import receipt.Receipt
import ui.eReceipt.components.Balance
import ui.eReceipt.components.LocationTitleBanner
import ui.eReceipt.components.OrderInformation
import ui.eReceipt.components.ReceiptContent
import ui.eReceipt.components.TransactionInformation

@Composable
fun DefaultReceipt(
    maxWidth: Dp,
    eReceipt: Receipt,
    merchantInformationStateFlow: StateFlow<MerchantFullInformationV3?>?,
    loggedInCustomerIdMatchesReceiptCustomerId: Boolean,
    isSimplified: Boolean = false,
) {
    HorizontalDivider(
        modifier = Modifier
            .widthIn(0.dp, maxWidth),
        color = Color.White,
        thickness = 32.dp
    )
    if (!isSimplified) {
        LocationTitleBanner(eReceipt.locationDetails, maxWidth)
    }
    Box(
        modifier = Modifier
            .widthIn(0.dp, maxWidth)
            .background(Color.White)
    ) {
        OrderInformation(eReceipt)
    }
    HorizontalDivider(
        modifier = Modifier
            .widthIn(0.dp, maxWidth),
        color = Color.White,
        thickness = 4.dp
    )
    ReceiptContent(eReceipt, maxWidth)
    if (!isSimplified) {
        if (merchantInformationStateFlow != null) {
            Balance(
                eReceipt.rewardBalanceMessage,
                merchantInformationStateFlow,
                loggedInCustomerIdMatchesReceiptCustomerId,
                maxWidth
            )
        }
    }
    HorizontalDivider(
        modifier = Modifier
            .widthIn(0.dp, maxWidth),
        color = Color.White,
        thickness = 16.dp
    )
    eReceipt.transactionDetails.filter { it.key != "Order ID" && it.key != "Date" && it.key != "Time" }.let {
        TransactionInformation(it, maxWidth)
    }
    HorizontalDivider(
        modifier = Modifier
            .widthIn(0.dp, maxWidth),
        color = Color.White,
        thickness = 16.dp
    )
    eReceipt.creditPricingFooter?.let {
        Column(
            modifier = Modifier
                .background(Color.White)
                .width(maxWidth),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Text(it, fontWeight = FontWeight.Normal, color = Color.Black,)
        }
    }
    HorizontalDivider(
        modifier = Modifier
            .widthIn(0.dp, maxWidth),
        color = Color.White,
        thickness = 8.dp
    )
}